import { render, staticRenderFns } from "./UserListItem.vue?vue&type=template&id=2441c418&scoped=true&"
import script from "./UserListItem.vue?vue&type=script&lang=ts&"
export * from "./UserListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441c418",
  null
  
)

export default component.exports